import ColourUtil from './Colour.util';

export * from './Colour.util';
export default ColourUtil;
